<template>
    <div class="clearfix w980">
        <div class="v100 weizhi fs12">
            首页 - 产品 - WP桌面</div>
        <product-menu now="wp8launcher" />
        <div class="v100 bigimg mt20">
            <img alt="WP桌面" src="@/assets/images/wp8_1.jpg?v=0908" />
            <div class="brand">
				<img src="@/assets/images/wp8_6.jpg" alt="WP桌面" height="75" width="121" />
			</div>
            <h1 style="display:block;position:absolute;left:-5999px">WP桌面</h1>
        </div>
        <div class="v100 gongneng">
            <dl>
                <img alt="手机一键变身WP8系统" class="fl" src="@/assets/images/wp8_2.jpg" />
                <dt class="fr">手机一键变身WP8系统</dt>
                <dd class="fr">
                    无需更换手机即可体验Windows Phone</dd>
            </dl>
            <dl>
                <img alt="极致丰富，无拘无束DIY" class="fr" src="@/assets/images/wp8_3.jpg" />
                <dt class="fl">极致丰富，无拘无束DIY</dt>
                <dd class="fl">
                    魅力百变的WP桌面可以自定义成任何风格</dd>
            </dl>
            <dl>
                <img alt="创意无限的主题分享" class="fl" src="@/assets/images/wp8_4.jpg" />
                <dt class="fr">创意无限的主题分享</dt>
                <dd class="fr">
                    数十万主题、壁纸任你选择，个性有品，独一无二</dd>
            </dl>
            <dl>
                <img alt="天生纯净无插件" class="fr" src="@/assets/images/wp8_5.jpg" />
                <dt class="fl">天生纯净无插件</dt>
                <dd class="fl">
                    没有任何插件和捆绑软件，依然初心</dd>
            </dl>
        </div>
    </div>

</template>

<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "wp8launcher",
  components: {
    ProductMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/function/wp8launcher.vue